import { HomeTimezoneIcon } from '../UI/Icons';

/**
 * TimezoneSelector - Buttons to switch time display between home and event timezones
 */
export default function TimezoneSelector({
  selectedTimezone,
  onChange,
  availableTimezones,
}) {
  function formatTimezoneLabel(tz) {
    const parts = tz.split('/');
    return parts[parts.length - 1].replace(/_/g, ' ');
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm mr-1" style={{ color: 'var(--color-text-muted)' }}>
        Display times in:
      </span>
      
      <button
        onClick={() => onChange('home')}
        className={`btn-sm flex items-center gap-1.5 ${
          selectedTimezone === 'home' ? 'btn-primary' : 'btn-secondary'
        }`}
      >
        <HomeTimezoneIcon size={14} />
        Home
      </button>
      
      {availableTimezones.map(tz => (
        <button
          key={tz}
          onClick={() => onChange(tz)}
          className={`btn-sm ${
            selectedTimezone === tz ? 'btn-primary' : 'btn-secondary'
          }`}
        >
          {formatTimezoneLabel(tz)}
        </button>
      ))}
    </div>
  );
}
